import { render, staticRenderFns } from "./myTraining_new.vue?vue&type=template&id=72e5c694&scoped=true"
import script from "./myTraining_new.vue?vue&type=script&lang=js"
export * from "./myTraining_new.vue?vue&type=script&lang=js"
import style0 from "./myTraining_new.vue?vue&type=style&index=0&id=72e5c694&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e5c694",
  null
  
)

export default component.exports